import { useState, useEffect } from "react";
import "./NewsStyle.css";
import NewsCard from "./Components/NewsCard";
import LoadingState from "./utils/LoadingState";
import ErrorState from "./utils/ErrorState";
import ArticleModal from "./Components/ArticleModal";
import NavBar from "../../../Admin/Dashboard/NavBar";
import ReactProSidebar from "../../../Admin/Dashboard/ReactProSidebar";
import { useCallback } from "react";
import { Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import api from "../../../../API/axiosInstance";
import { showToast } from "../toastUtils";
import { jwtDecode } from "jwt-decode";

export default function NewsApp() {
  const [articles, setArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("Token");
  const [crawlNews, setCrawlNews] = useState([]);
  const [totalPageCount, settotalPageCount] = useState(0);
  const [todayAndAllNews, settodayAndAllNews] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [todayNewsCount, settodayNewsCount] = useState(0);
  const [totalNewsCount, settotalNewsCount] = useState(0);
  const [todaySentimentPercent, settodaySentimentPercent] = useState({});
  const [totalSentimentpercent, settotalSentimentpercent] = useState({});

  const fetchNewsData = useCallback(
    async (page) => {
      setIsLoading(true);

      try {
        const token = localStorage.getItem("Token");

        if (!token) {
          console.error("No token found in localStorage");
          return; // Stop execution if the token is missing
        }

        const response = await api.get(
          `/news/show`,

          {
            params: showAll ? { page, today: false } : { page, today: true },
            headers: {
              // Security Headers
              "X-XSS-Protection": "1; mode=block",
              "X-Content-Type-Options": "nosniff",
              "X-Frame-Options": "DENY",
              "Referrer-Policy": "strict-origin-when-cross-origin",
              "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

              // Standard Headers
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          settodayAndAllNews(response.data.news);
          settotalPageCount(response.data.totalPages);
          {
            showAll
              ? settotalNewsCount(response.data.totalCount)
              : settodayNewsCount(response.data.totalCount);
          }

          // getCurrentItems()
        } else {
          //
        }
      } catch (err) {
        console.error("Error fetching news data:", err);
      } finally {
        setIsLoading(false);
      }
    },
    [showAll, token]
  );

  const handleSentimentCounts = async () => {
    try {
      const url = showAll
        ? `/news/sentiment?today=false`
        : `/news/sentiment?today=true`;

      const response = await api.get(url, {
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

          // Standard Headers
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const { positive, negative } = response.data;

        // Calculate percentages
        const calculateSentimentPercentages = (data) => {
          const total = data.negative + data.positive;

          if (!total) {
            return {
              positivePercentage: "0",
              negativePercentage: "0",
            };
          }

          return {
            positivePercentage: ((data.positive / total) * 100).toFixed(2),
            negativePercentage: ((data.negative / total) * 100).toFixed(2),
          };
        };

        const sentimentPercentages = calculateSentimentPercentages({
          positive: positive,
          negative: negative,
        });

        // Update state using your original state setter names
        if (showAll) {
          settotalSentimentpercent(sentimentPercentages);
        } else {
          settodaySentimentPercent(sentimentPercentages);
        }
      } else {
        console.error("Error fetching sentiment data:", response.data);
      }
    } catch (err) {
      console.error("Error fetching news data:", err);
    }
  };

  const startCrawling = async () => {
    // Display a success toast message indicating the start of crawling
    showToast(`Embarking on a News Hunt! 🌍✨`, "success");
    try {
      // Send a POST request to the `postNewsScraperTool` endpoint with an Authorization token
      const response = await api.post(
        `/scraping/news`,
        {},

        {
          headers: {
            // Security Headers
            "X-XSS-Protection": "1; mode=block",
            Authorization: `Bearer ${token}`,
            "X-Content-Type-Options": "nosniff",
            "X-Frame-Options": "DENY",
            "Referrer-Policy": "strict-origin-when-cross-origin",
            "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

            // Standard Headers
            "Content-Type": "application/json",
          },
        }
      );
      //
      if (response.status === 200) {
        showToast(`Headlines Unlocked! 🔓📰. Hunt Successful! 📡🗞️`, "success");
      } else {
        showToast(`Error! 📭🛑 The News Is Stuck in Limbo!`, "error");
      }
    } catch (err) {
      showToast("Error! ⚠️ The News Engine Needs a Jumpstart!", "error");
    }
  };

  const startAnalysis = async () => {
    showToast("Diving into News Data! 📊🧠", "success");

    try {
      const response = await api.post(
        "http://10.226.53.238:5005/agents/sensational-news",
        { agent: "sensational-news" },
        {


          headers: {
            // Security Headers
            "X-XSS-Protection": "1; mode=block",
            // Authorization: `Bearer ${token}`,
            "X-Content-Type-Options": "nosniff",
            "X-Frame-Options": "DENY",
            "Referrer-Policy": "strict-origin-when-cross-origin",
            "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

            // Standard Headers
            "Content-Type": "application/json",
          },
        }
      );

      // Handle the response status
      if (response.status === 204) {
        // Display a warning toast message if the news basket is empty
        showToast("Empty News Basket! 🧺🔒", "warn");
      } else if (response.status === 200) {
        // Display a success toast message and reload the page after 2 seconds
        showToast(
          "Analysis Adventure Complete! 🌍🗞️. The News Journey Ends! 🏁✨",
          "success"
        );
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (err) {
      // Display an error toast message if any error occurs
      showToast(
        "Uh-oh! 🚧 A Sneaky Glitch Occurred! 🎭 Something Went Awry Behind the Curtain!",
        "error"
      );
    }
  };

  const toggleNewsView = () => {
    setShowAll((prev) => !prev);
    setCurrentPage(1);
    handleSentimentCounts();
  };

  const refreshNews = () => {
    fetchNewsData(currentPage);
  };

  useEffect(() => {
    fetchNewsData(currentPage);
    handleSentimentCounts();
  }, [currentPage, showAll]);

  // Fetch data from FastAPI backend
  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        // Replace with your actual FastAPI endpoint
        
        const response = await fetch(
          "http://10.226.37.205:8080/news/filter?page=0",
          {
            method: "GET",
            headers: {
              // Security Headers
              "X-XSS-Protection": "1; mode=block",
              Authorization: `Bearer ${token}`,
              "X-Content-Type-Options": "nosniff",
              "X-Frame-Options": "DENY",
              "Referrer-Policy": "strict-origin-when-cross-origin",
              "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

              // Standard Headers
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }
        const data = await response.json();
        setArticles(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching articles:", err);
        setError("Failed to load news articles. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div className="container">
      <NavBar />
      {/* <div className="news-app-background"> */}
      <main className="news-app-main">
        <header className="news-app-header">
          <h1 className="news-app-title">NewsLens</h1>
          <p className="news-app-subtitle">
            Your window to transparent journalism
          </p>
          <Button
            variant="text"
            onClick={refreshNews}
            startIcon={<RefreshIcon />}
            style={{ margin: "10px", borderColor: "green", color: "green" }}
          >
            Refresh
          </Button>

          <Button
            variant="text"
            onClick={startCrawling}
            style={{ marginRight: "10px" }}
          >
            Fetch News
          </Button>
          <Button
            variant="text"
            onClick={startAnalysis}
            style={{ marginRight: "10px" }}
          >
            Analyse News
          </Button>

          <Button
            variant="text"
            onClick={() => toggleNewsView(currentPage)}
            style={{
              marginRight: "10px",
              borderColor: showAll ? "" : "red", // Red outline if showAll is true, otherwise green
              color: showAll ? "" : "red", // Red text if showAll is true, otherwise green
            }}
          >
            {showAll ? "Show Today's News" : "Show All News"}
          </Button>
        </header>
        {loading ? (
          <LoadingState />
        ) : error ? (
          <ErrorState />
        ) : articles.length === 0 ? (
          <div className="news-app-empty-state">
            <p className="news-app-empty-text">
              No news articles available at the moment
            </p>
          </div>
        ) : (
          <div className="news-app-grid">
            {articles.news.map((article) => (
              <NewsCard
                key={article._id}
                article={article}
                setSelectedArticle={setSelectedArticle}
              />
            ))}
          </div>
        )}

        {/* Modal */}
        {selectedArticle && (
          <ArticleModal
            selectedArticle={selectedArticle}
            setSelectedArticle={setSelectedArticle}
          />
        )}
      </main>
      {/* </div> */}
      <ReactProSidebar />
    </div>
  );
}
